import { motion } from 'framer-motion';

export default function StatsCard({ title, value, unit, icon, trend, color = 'blue' }) {
  const colorClasses = {
    blue: 'from-blue-500/20 to-blue-600/20 border-blue-500/30',
    green: 'from-green-500/20 to-green-600/20 border-green-500/30',
    yellow: 'from-yellow-500/20 to-yellow-600/20 border-yellow-500/30',
    purple: 'from-purple-500/20 to-purple-600/20 border-purple-500/30',
    red: 'from-red-500/20 to-red-600/20 border-red-500/30',
    ocean: 'from-ocean-light/20 to-ocean-blue/20 border-ocean-light/30',
  };

  const trendColorClass = trend?.direction === 'up'
    ? 'text-green-400'
    : trend?.direction === 'down'
    ? 'text-red-400'
    : 'text-gray-400';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className={`relative overflow-hidden rounded-xl bg-gradient-to-br ${colorClasses[color]} border backdrop-blur-sm p-6`}
    >
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10">
        <div className="flex items-start justify-between mb-4">
          <div>
            <p className="text-sm font-medium text-ocean-sky mb-1">{title}</p>
            <div className="flex items-baseline">
              <h3 className="text-3xl font-bold text-white">
                {value !== null && value !== undefined ? value : '--'}
              </h3>
              {unit && <span className="ml-2 text-lg text-ocean-sky">{unit}</span>}
            </div>
          </div>

          {/* Icon */}
          {icon && (
            <div className="p-3 bg-white/10 rounded-lg">
              {icon}
            </div>
          )}
        </div>

        {/* Trend */}
        {trend && (
          <div className={`flex items-center text-sm ${trendColorClass}`}>
            {trend.direction === 'up' && (
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            )}
            {trend.direction === 'down' && (
              <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
            <span>{trend.value}% {trend.label}</span>
          </div>
        )}
      </div>
    </motion.div>
  );
}
